import { useState } from "react"
import { COMPOSITOR_FONTS, loadFont } from "@/lib/registry/compositor-fonts"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import { cn } from "@/lib/utils"

interface FontPickerProps {
  value: string
  onChange: (family: string) => void
}

export function FontPicker({ value, onChange }: FontPickerProps) {
  const [open, setOpen] = useState(false)
  const [search, setSearch] = useState("")

  const filtered = search
    ? COMPOSITOR_FONTS.filter((f) => f.family.toLowerCase().includes(search.toLowerCase()))
    : COMPOSITOR_FONTS

  async function handleSelect(family: string) {
    await loadFont(family, "400")
    onChange(family)
    setOpen(false)
    setSearch("")
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          className={cn(
            "w-full h-7 px-2 text-left text-[12px] rounded border border-border/50 bg-input hover:border-border transition-colors truncate"
          )}
          style={{ fontFamily: value }}
        >
          {value}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-52 p-0" align="start">
        <div className="p-2 border-b border-border/50">
          <input
            autoFocus
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search fonts..."
            className="w-full text-[12px] bg-transparent outline-none placeholder:text-muted-foreground/50"
          />
        </div>
        <div className="max-h-52 overflow-y-auto">
          {filtered.map((font) => (
            <button
              key={font.family}
              onClick={() => handleSelect(font.family)}
              className={cn(
                "w-full px-3 py-1.5 text-left text-[12px] hover:bg-accent transition-colors",
                value === font.family && "bg-accent font-medium"
              )}
              style={{ fontFamily: font.family }}
            >
              {font.family}
            </button>
          ))}
          {filtered.length === 0 && (
            <div className="px-3 py-4 text-[12px] text-muted-foreground text-center">No fonts found</div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  )
}
